import { useState, useCallback } from "react";

type UseDisclosureReturn = {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    onToggle: () => void;
};

/**
 * Custom hook for managing disclosure state, primarily for dialogs.
 *
 * @param initialState - Optional initial open state (defaults to false)
 * @returns An object containing the disclosure state and methods to control it
 */
const useDisclosure = (initialState: boolean = false): UseDisclosureReturn => {
    const [isOpen, setIsOpen] = useState<boolean>(initialState);

    const onOpen = useCallback(() => {
        setIsOpen(true);
    }, []);

    const onClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const onToggle = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    return {
        isOpen,
        onOpen,
        onClose,
        onToggle,
    };
};

export default useDisclosure;
